import { Grid, Paper } from "@material-ui/core";
import * as React from "react";
import { SelectInput } from "react-admin";
import { Separator } from "../../../../Components/Separator";
import { UploadFile } from "../../../../Components/UploadFile";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { SectionTitle } from "../../../../Components/SectionTitle";
import "./PbhRequestOrderEdit.css";
import { GetPbhRequestServiceableFileType, PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";
import PbhFileGrid from "../../../../../src/Components/PbhFileGrid/PbhFileGrid";
import { SourcePbhRequestOrder } from "../Constant/Source";
import { useAccessControl } from "@airborne/react-admin";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";
import { PbhRequestOrderTabEnum } from "../../../../../src/Enums/PbhRequestOrderTabEnum";

export default function PbhRequestOrderFiles(props) {
  const { canPerform: canPerformInfo } = useAccessControl(SourcePbhRequestOrder, "pbhinfofiles");
  const { canPerform: canPerformSvc } = useAccessControl(SourcePbhRequestOrder, "pbhsvcfiles");
  const { canPerform: canPerformUnsvc } = useAccessControl(SourcePbhRequestOrder, "pbhusvcfiles");
  const canUpload = (): boolean => {
    if (props.isPageDisabled) {
      return false;
    }
    if (props?.mainData?.requestStatus === PbhRequestStatus.Cancelled) {
      return false;
    }
    return true;
  };
  const isCanPerform = (): boolean => {
    let currentTab: number = Number(props?.activeTab);
    switch (currentTab) {
      case PbhRequestOrderTabEnum.InfoTab:
        return canPerformInfo;
      case PbhRequestOrderTabEnum.ServiceableTab:
        return canPerformSvc;
      case PbhRequestOrderTabEnum.UnserviceableTab:
        return canPerformUnsvc;
      default:
        return false;
    }
  };

  return (
    <div>
      {isCanPerform() && (
        <Paper>
          <hr />
          <Grid item>
            <hr />
            <SectionTitle label="ATTACHMENTS" align="Center" color="Primary" />
            <hr />
            {canUpload() && (
              <>
                <SelectInput
                  source="fileType"
                  inputProps={{ value: props?.selectedRequestOrderFileType }}
                  choices={
                    props.isPbhRequestInfoUpdate
                      ? GetPbhRequestServiceableFileType.filter(x => x.Value == PbhRequestFileType.Mailings)
                      : GetPbhRequestServiceableFileType
                  }
                  optionText="Description"
                  optionValue="Value"
                  fullWidth
                  required
                  variant="outlined"
                  onChange={props?.changeRequestOrderFileType}
                />

                <UploadFile
                  label=""
                  multiple={false}
                  disabled={props?.selectedRequestOrderFileType === null}
                  onHandleFileExecute={() => props?.getRequestDetail()}
                  source="pbhrequestorderfilerelations"
                  object={{
                    pbhRequestOrderId: props?.requestId,
                    pbhRequestFileTypeGroupEnum:
                      props?.activeTab == RequestOrderTabEnum.InfoTab
                        ? PbhRequestFileType.Info
                        : props?.activeTab == RequestOrderTabEnum.ServiceableTab
                          ? PbhRequestFileType.Serviceable
                          : PbhRequestFileType.Unserviceable,
                    pbhRequestFileTypeEnum: props?.selectedRequestOrderFileType,
                  }}
                />
              </>
            )}
            <Separator />
            <PbhFileGrid
              source="pbhrequestorderfilerelations"
              filter={{
                pbhRequestOrderId__eq: props?.requestId.toString(),
                pbhRequestFileTypeGroupEnum__eq:
                  props?.activeTab == RequestOrderTabEnum.InfoTab
                    ? PbhRequestFileType.Info
                    : props?.activeTab == RequestOrderTabEnum.ServiceableTab
                      ? PbhRequestFileType.Serviceable
                      : PbhRequestFileType.Unserviceable,
              }}
              fileAction={() => props?.getRequestDetail()}
              canRemove={true}
              activeTab={props?.activeTab}
            />
          </Grid>
        </Paper>
      )}
    </div>
  );
}
